import { useQuery, QueryResult } from '@apollo/client';
import { setLocalizationCountryCookie } from '@app/helpers/localization';

import { LOCALIZATION_COUNTRY_QUERY } from './queries';
import { LocalizationCountryQuery } from './__generated__/LocalizationCountryQuery';

const useLocalizationCountry = (): UseLocalizationCountryResult => {
  const { data, ...queryState } = useQuery<LocalizationCountryQuery>(
    LOCALIZATION_COUNTRY_QUERY
  );

  return {
    ...queryState,
    setLocalizationCountry: setLocalizationCountryCookie,
    country: data?.localizationCountry,
  };
};

export default useLocalizationCountry;

interface UseLocalizationCountryResult
  extends Omit<QueryResult<LocalizationCountryQuery>, 'data'> {
  country?: string;
  setLocalizationCountry: (country: string) => void;
}
